<template lang="pug">
div.box
    v-server-table(
        :url="datatableUrl",
        :name="tableName",
        ref="datatable",
        :columns="columns",
        :options="options"
    )
</template>

<script>
import dateFormatMixin from '../../../mixins/date-format';

export default {
    mixins: [dateFormatMixin],

    data() {
        return {
            tableName: 'CASH_ADJUSMENT',
            columns: [
                'adjusted_at',
                'staff',
                'type',
                'amount',
                'remarks',
                'outlet',
            ],
            options: {
                useReportFilter: true,
                texts: {
                    title: 'Cashflow Report',
                    description: 'Cashflow transactions by date',
                },
                skin: 'table m-b-0 b-b',
                pdf_url: Laroute.route(
                    'franchise.report.cash_adjustments.export',
                    { type: 'PDF' },
                ),
                csv_url: Laroute.route(
                    'franchise.report.cash_adjustments.export',
                    { type: 'CSV' },
                ),
                xls_url: Laroute.route(
                    'franchise.report.cash_adjustments.export',
                    { type: 'XLSX' },
                ),
                rowClassCallback(row) {
                    if (row.parent) {
                        return 'table-row-divider';
                    }

                    return null;
                },
                responseAdapter: res => {
                    const data = res.data.data;

                    data.forEach(c => {
                        this.$set(
                            c,
                            'date',
                            moment(c.adjusted_at)
                                .format('DD MMM YYYY')
                                .toUpperCase(),
                        );
                    });

                    const grouped = _.groupBy(data, 'date');
                    const results = [];

                    _.forEach(grouped, (rows, date) => {
                        results.push({
                            adjusted_at: date,
                            staff: '',
                            type: '',
                            amount: '',
                            remarks: '',
                            outlet: '',
                            parent: true,
                        });

                        rows.forEach(row => {
                            row.parent = false;
                            this.$set(
                                row,
                                'adjusted_at',
                                this.dateFormat(row.adjusted_at),
                            );
                            results.push(row);
                        });
                    });

                    return {
                        data: results,
                        count: res.data.count,
                    };
                },
            },
        };
    },

    computed: {
        datatableUrl() {
            return Laroute.route('franchise.report.cash_adjustments.all');
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/report/cash-adjustment/cash-adjustment-list.vue